import { useState, useEffect } from "react";
import { Tabs, Form, Select, message } from "antd";
import PropTypes from "prop-types";
import moment from 'moment';
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { AddUser } from '../../style';
import { updateQuotes } from '../../../../Api/Services/QuotesApiService'
import { setEditCall } from '../../../../redux/CrmReduxCalls/EditNavCtrl';
import { BasicFormWrapper } from '../../../styled';
import CopyButton from '../GlobalComponents/CopyButton'
import UpdateConnectionPopup from '../../Popup/UpdateConnectionPopup';

const { Option } = Select;

const LeadTabPage = ({ displayData, Billing, billingAddress, Shipping, shipingAddress, getDetailsData }) => {
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const { TabPane } = Tabs;
    const [form] = Form.useForm();
    const [inlineStatus, setInlineStatus] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [edit] = useState(true)
    const handleEditFieldChange = () => {
        setInlineStatus(!inlineStatus)
        dispatch(setEditCall(!inlineStatus));
        getDetailsData()
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const onSubmit = async (values) => {
        const { status } = values;
        const payload = {
            quotesStatus: status,
        }
        try {
            const response = await updateQuotes(payload, displayData?.quotesId)
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
                else {
                    message.success(
                        <span>
                            Quote <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                        </span>
                    );
                    dispatch(setEditCall(false));
                    setInlineStatus(false)
                    getDetailsData()
                }
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    useEffect(() => {
        if (displayData) {
            form.setFieldsValue({
                status: displayData.quotesStatus,
            })
        }
    }, [displayData])
    const getRefreshtheTable = () => {
        dispatch(setEditCall(false));
        setInlineStatus(false)
        getDetailsData()
    }
    return (
        <>
            <AddUser>
                <div className="user-info-form">
                    <Form style={{ width: '100%' }} form={form} name="info" colon={false} onFinish={onSubmit} onFinishFailed={onFinishFailed}>
                        <BasicFormWrapper>
                            <div className="add-product-block">
                                <div className="add-product-content">
                                    <Tabs defaultActiveKey="1">
                                        <TabPane tab="Basic Info" key="1">
                                            {/* <Form.Item label="Quote Name" name="subject" className="custom-form-item">
                                            <span className="">{displayData?.quotesName}</span>
                                        </Form.Item>
                                        <Form.Item label="Quote Number" name="number" className="custom-form-item">
                                            <span className="">{displayData?.quotesNumber}</span>
                                        </Form.Item> */}
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <div style={{ flex: 1 }}>
                                                    <Form.Item label="Quote Status" name="status" className="custom-form-item" rules={inlineStatus ? [{ required: true, message: 'Please select status' }] : [{ required: false }]}>
                                                        {inlineStatus ? <Select style={{ width: '100%', textAlign: "left" }} placeholder="Please select quote status">
                                                            <Option value="Draft">Draft</Option>
                                                            <Option value="Confirmed">Confirmed</Option>
                                                            <Option value="Delivered">Delivered</Option>
                                                            {/* <Option value="Negotiation">Negotiation</Option>
                                                        <Option value="Closed Won">Closed Won</Option>
                                                        <Option value="Closed Lost">Closed Lost</Option>
                                                        <Option value="On Hold">On Hold</Option> */}
                                                        </Select> :
                                                            <div
                                                                className={edit ? "edit-span text_icon" : ""}
                                                            // style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: edit ? "pointer" : "default", width: '100%' }}
                                                            >
                                                                <span className={`table_list_clicks status-text Qstatus${displayData?.quotesStatus === "On Hold" ? "OnHold" : displayData?.quotesStatus === "Closed Lost" ? "ClosedLost" : displayData?.quotesStatus === "Closed Won" ? "ClosedWon" : displayData?.quotesStatus}`}>{displayData?.quotesStatus}</span>
                                                                {edit && <FeatherIcon icon="edit-3" size={16} className="btn-edit" onClick={() => handleEditFieldChange()} />}
                                                            </div>}
                                                    </Form.Item>
                                                </div>
                                                {inlineStatus ?
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 5, marginTop: 10 }}>
                                                        <div
                                                            className="Hover-Refresh2 back-hover1 able-style"
                                                            role="button"
                                                            tabIndex={0}
                                                            title="Cancel"
                                                            onClick={() => {
                                                                handleEditFieldChange(); getDetailsData()
                                                            }}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                    handleEditFieldChange(); getDetailsData()
                                                                }
                                                            }}
                                                            aria-label="cancel"
                                                        >
                                                            <FeatherIcon icon="x" size={20} className="btn-cancel" />
                                                        </div>
                                                        <div
                                                            className="Hover-Refresh2 back-hover1 able-style"
                                                            role="button"
                                                            tabIndex={0}
                                                            title="Save"
                                                            onClick={() => form.submit()}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                    form.submit();
                                                                }
                                                            }}
                                                            aria-label="save"
                                                        >
                                                            <FeatherIcon icon="check" size={20} className="btn-save" style={{ marginRight: 0 }} />
                                                        </div>
                                                    </div> : <></>}
                                            </div>
                                            <Form.Item label="Issue Date" name="isssueDate" className="custom-form-item">
                                                <span className="">{displayData !== undefined && displayData.issueDate ? moment(displayData !== undefined && displayData.issueDate).format(profile.dateFormate) : (displayData !== undefined && displayData.issueDate && moment(displayData !== undefined && displayData.issueDate).format("YYYY-MM-DD"))}</span>
                                            </Form.Item>
                                            <Form.Item label="Expiry Date" name="date" className="custom-form-item">
                                                <span className="">{displayData !== undefined && displayData.validUntil ? moment(displayData !== undefined && displayData.validUntil).format(profile.dateFormate) : (displayData !== undefined && displayData.validUntil && moment(displayData !== undefined && displayData.validUntil).format("YYYY-MM-DD"))}                                            </span>
                                            </Form.Item>
                                        </TabPane>
                                        <TabPane tab="Billing Address" key="2">
                                            {Billing ?
                                                <>
                                                    <Form.Item label="Name" className="custom-form-item">
                                                        {billingAddress?.name}
                                                    </Form.Item>
                                                    <Form.Item label="Street name and No" className="custom-form-item">
                                                        {billingAddress?.street}
                                                    </Form.Item>
                                                    <Form.Item label="City" className="custom-form-item">
                                                        {billingAddress?.city}
                                                    </Form.Item>
                                                    <Form.Item label="State" className="custom-form-item">
                                                        {billingAddress?.state}
                                                    </Form.Item>
                                                    <Form.Item label="Zip Code" name="postcode" className="custom-form-item">
                                                        {(billingAddress?.zipcode === "0" || billingAddress.zipcode === 0) ? "" : (billingAddress?.zipcode)}
                                                    </Form.Item>
                                                    <Form.Item label="Country" className="custom-form-item">
                                                        {billingAddress?.country}
                                                    </Form.Item>
                                                    <Form.Item label="Email" className="custom-form-item">
                                                        <span className="call-Optionholder">{(billingAddress?.email && billingAddress?.email !== "") ? <><span>{billingAddress?.email}</span> <CopyButton apiKey={billingAddress?.email} type="Email" /> </> : ""}</span>
                                                    </Form.Item>
                                                    <Form.Item label="Mobile" className="custom-form-item">
                                                        {(billingAddress?.mobile === "0" || billingAddress?.mobile === 0) ? "" : billingAddress?.mobile}
                                                        {/* <span className="call-Optionholder">{(billingAddress?.mobile === "0" || billingAddress?.mobile === 0) ? "" : <><span>{billingAddress?.mobile}</span> <CallButton number={billingAddress?.mobile} /> </>}</span> */}
                                                    </Form.Item></>
                                                : <></>
                                            }
                                        </TabPane>
                                        <TabPane tab="Shipping Address" key="3">
                                            {Shipping ?
                                                <>
                                                    <Form.Item label="Name" className="custom-form-item">
                                                        {shipingAddress?.name}
                                                    </Form.Item>
                                                    <Form.Item label="Street name and No" name="street" className="custom-form-item">
                                                        {shipingAddress?.street}
                                                    </Form.Item>
                                                    <Form.Item label="City" className="custom-form-item">
                                                        {shipingAddress?.city}
                                                    </Form.Item>
                                                    <Form.Item label="State" className="custom-form-item">
                                                        {shipingAddress?.state}
                                                    </Form.Item>
                                                    <Form.Item label="Zip Code" name="postcode" className="custom-form-item">
                                                        {(shipingAddress?.zipcode === "0" || shipingAddress.zipcode === 0) ? "" : (shipingAddress?.zipcode)}
                                                    </Form.Item>
                                                    <Form.Item label="Country" className="custom-form-item">
                                                        {shipingAddress?.country}
                                                    </Form.Item>
                                                    <Form.Item label="Email" className="custom-form-item">
                                                        <span className="call-Optionholder">{(shipingAddress?.email && shipingAddress?.email !== "") ? <><span>{shipingAddress?.email}</span> <CopyButton apiKey={shipingAddress?.email} type="Email" /> </> : ""}</span>
                                                    </Form.Item>
                                                    <Form.Item label="Mobile" className="custom-form-item">
                                                        {(shipingAddress?.mobile === "0" || shipingAddress?.mobile === 0) ? "" : shipingAddress?.mobile}
                                                        {/* <span className="call-Optionholder">{(shipingAddress?.mobile === "0" || shipingAddress?.mobile === 0) ? "" : <><span>{shipingAddress?.mobile}</span> <CallButton number={shipingAddress?.mobile} /> </>}</span> */}
                                                    </Form.Item></>
                                                : <></>
                                            }
                                        </TabPane>
                                        <TabPane tab="Quotes Details" key="4">
                                            <Form.Item label="Terms and Condition" name="termsandCondition" className="custom-form-item" >
                                                <span>{displayData?.termsAndCondition}</span>
                                            </Form.Item>
                                            <Form.Item label="Description" name="description" className="custom-form-item" >
                                                <span>{displayData?.description}</span>
                                            </Form.Item>
                                        </TabPane>
                                    </Tabs>
                                </div>
                            </div>
                        </BasicFormWrapper>
                    </Form >
                </div>
            </AddUser >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Quote" getCallBack={getRefreshtheTable} />}
        </>
    )
}
LeadTabPage.propTypes = {
    displayData: PropTypes.object.isRequired,
    Billing: PropTypes.bool.isRequired,
    billingAddress: PropTypes.object.isRequired,
    Shipping: PropTypes.bool.isRequired,
    shipingAddress: PropTypes.object.isRequired,
    getDetailsData: PropTypes.func.isRequired,
}
export default LeadTabPage;
